import { render, staticRenderFns } from "./InstallationTab.vue?vue&type=template&id=2c4e6f5a&scoped=true&"
import script from "./InstallationTab.vue?vue&type=script&lang=js&"
export * from "./InstallationTab.vue?vue&type=script&lang=js&"
import style0 from "./InstallationTab.vue?vue&type=style&index=0&id=2c4e6f5a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4e6f5a",
  null
  
)

export default component.exports